export enum DeeplinkParameters {
    currency = 'currency',
    ffdebug = 'ffdebug',
    language = 'language',
    mewsAdultCount = 'mewsAdultCount',
    mewsAvailabilityBlockId = 'mewsAvailabilityBlockId',
    mewsChildCount = 'mewsChildCount',
    mewsCityId = 'mewsCityId',
    mewsDistributorOpened = 'mewsDistributorOpened',
    mewsEnd = 'mewsEnd',
    mewsEnterpriseId = 'mewsEnterpriseId',
    mewsFreeCancellationOnly = 'mewsFreeCancellationOnly',
    mewsHotel = 'mewsHotel',
    mewsPaymentCardId = 'mewsPaymentCardId',
    mewsPropertyReturnUrl = 'mewsPropertyReturnUrl',
    mewsReservationGroupId = 'mewsReservationGroupId',
    mewsReservationIds = 'mewsReservationIds',
    mewsRoom = 'mewsRoom',
    mewsRoute = 'mewsRoute',
    mewsSort = 'mewsSort',
    mewsStart = 'mewsStart',
    mewsVoucherCode = 'mewsVoucherCode',
}
